<template>
  <span>
    <!-- EDIT BANK ACCOUNTS MODAL -->
    <BankAccountDialog
      isEdit
      v-model="openEditAccDialog"
      :selectedAccount="account"
      :companyID="id"
      :isEUR="isEUR"
      @dialog-closed="closeAccDialog"
    />
    <!-- LOADER -->
    <v-progress-linear
      v-show="loading"
      height="2"
      value="15"
      :indeterminate="true"
    />
    <v-data-table
      :items="accounts"
      hide-default-footer
      :headers="headers"
      :hide-default-header="accounts.length === 0"
      class="accounts-headers"
      :items-per-page="-1"
    >
      <template #header="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.value"
          >
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template #item="props">
        <tr class="table-items">
          <td class="acc-table-4">
            {{
              isEUR ? EURAccount(props).iban : GBPAccount(props).account_number
            }}
            <v-tooltip right>
              <template #activator="{ on }">
                <span v-on="on">
                  <v-btn
                    text
                    small
                    fab
                    class="ma-0 pa-0 copy-btn align-content-end"
                    @click.prevent.self
                    v-clipboard:copy="
                      isEUR
                        ? EURAccount(props).iban
                        : GBPAccount(props).account_number
                    "
                  >
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </span>
              </template>
              <span> Copy to clipboard </span>
            </v-tooltip>
          </td>
          <td class="acc-table-4">
            {{ isEUR ? EURAccount(props).bic : GBPAccount(props).sort_code }}
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-btn
                    text
                    small
                    fab
                    class="copy-btn align-content-end"
                    @click.prevent.self
                    v-clipboard:copy="
                      isEUR
                        ? EURAccount(props).bic
                        : GBPAccount(props).sort_code
                    "
                  >
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </span>
              </template>
              <span> Copy to clipboard </span>
            </v-tooltip>
          </td>
          <td class="acc-table-2">
            {{ props.item.currency }}
          </td>
          <v-tooltip
            top
            :disabled="!hasPermission.changeAccountState"
          >
            <template #activator="{ on }">
              <td
                v-on="on"
                class="text-right pr-0 dropdown-actions acc-table-4"
                :class="{
                  'pointer-not-allowed': !hasPermission.changeAccountState
                }"
              >
                <v-tooltip
                  bottom
                  :disabled="hasPermission.changeAccountState"
                  class="icon-dropdown"
                >
                  <template #activator="{ on }">
                    <base-dropdown
                      v-on="on"
                      showIcon
                      :options="dropdownOptions"
                      icon="mdi-dots-vertical"
                      btn-color="white"
                      btn-depressed
                      list-subheader
                      btn-color-hover="disabledGrey"
                      v-model="selected"
                      :class="{
                        'disable-events': !hasPermission.changeAccountState
                      }"
                      class="btn-dropdown-content"
                      @option-selected="isOpenDialog(props.item)"
                    />
                  </template>
                  <span>{{ notAccessMessage }}</span>
                </v-tooltip>
              </td>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </tr>
      </template>
    </v-data-table>
  </span>
</template>

<script>
import BaseDropdown from 'src/components/base/base-dropdown.vue'
import { NOT_ACCESS_MESSAGE } from 'src/constants.js'
import BankAccountDialog from '../../../../../components/accounts-dialog/bank-account-dialog.vue'
import { DROPDOWN_OPTIONS } from './helpers'

export default {
  name: 'BankAccountsTable',
  components: {
    BaseDropdown,
    BankAccountDialog
  },
  data() {
    return {
      dropdownOptions: DROPDOWN_OPTIONS,
      selected: '',
      account: {},
      notAccessMessage: NOT_ACCESS_MESSAGE,
      openEditAccDialog: false
    }
  },
  props: {
    id: { type: String, required: true },
    isEUR: { type: Boolean, default: false },
    accounts: { type: Array, required: true },
    headers: { type: Array, required: true },
    loading: { type: Boolean, required: true }
  },
  computed: {
    hasPermission() {
      return this.$store.getters.hasPermission
    }
  },
  methods: {
    isOpenDialog(acc) {
      this.account = acc
      this.openEditAccDialog = true
    },
    closeAccDialog(value) {
      this.openEditAccDialog = false
      this.account = {}
      this.$emit('dialog-closed', value)
    },
    isTextTruncate(txt) {
      if (txt.length > 15) return true
    },
    EURAccount(props) {
      return {
        iban: props.item.iban?.iban || props.item.iban,
        bic: props.item.iban?.bic || props.item.bic
      }
    },
    GBPAccount(props) {
      return {
        account_number:
          props.item.scan?.account_number || props.item.account_number,
        sort_code: props.item.scan?.sort_code || props.item.sort_code
      }
    }
  }
}
</script>

<style lang="scss">
.accounts-headers {
  border-top: 1px solid var(--v-accent15-base) !important;

  th {
    border-bottom: none !important;
    padding-left: 0 !important;
  }

  td {
    padding-left: 0 !important;
    height: 35px !important;
  }
}

.pointer-not-allowed > .icon-dropdown > span > .segmentedDropdown {
  background-color: #fff !important;
}
</style>
